var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bdg-img" }, [
    _c("div", { staticClass: "bdg-cor" }, [
      _c("div", { staticClass: "pop-wrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("i", { staticClass: "icon-close", on: { click: _vm.hidelogin } }, [
          _vm._v("×")
        ]),
        _vm._v(" "),
        !_vm.haveSubmit
          ? _c("div", [
              _c("p", [_vm._v("Enter a new password to update.")]),
              _vm._v(" "),
              _c("h3", [
                _vm._v("Your password must contain minimum of 8 characters")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "inputItem" }, [
                _c("i", { staticClass: "title" }, [_vm._v("New Password")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.pswd,
                      expression: "pswd"
                    }
                  ],
                  attrs: { maxlength: "16", type: "password" },
                  domProps: { value: _vm.pswd },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.pswd = $event.target.value
                      },
                      _vm.handleInput
                    ]
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inputItem",
                  staticStyle: { "margin-bottom": "42px" }
                },
                [
                  _c("i", { staticClass: "title" }, [
                    _vm._v("Re-type password")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.repswd,
                        expression: "repswd"
                      }
                    ],
                    class: { red: _vm.warn },
                    attrs: { maxlength: "16", type: "password" },
                    domProps: { value: _vm.repswd },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.repswd = $event.target.value
                        },
                        _vm.handleInput
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _vm.warn
                    ? _c("i", {
                        staticClass: "close",
                        on: {
                          click: function($event) {
                            return _vm.clean("repswd")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.warn
                    ? _c("strong", { staticStyle: { width: "100%" } }, [
                        _vm._v("Your password don't match. Please try again")
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "colored",
                  class: { disabled: _vm.disable },
                  attrs: { disabled: _vm.disable },
                  on: { click: _vm.save }
                },
                [_vm._v("\n          Save password\n        ")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.haveSubmit
          ? _c("div", [
              _vm._m(1),
              _vm._v(" "),
              _c("i", {
                staticClass: "home",
                staticStyle: { cursor: "pointer" },
                on: { click: _vm.login }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "h5",
        {
          staticStyle: {
            position: "absolute",
            left: "0",
            bottom: ".5rem",
            width: "100%",
            "font-size": ".22rem",
            "line-height": ".42rem",
            color: "#FFFFFF",
            "text-align": "center"
          }
        },
        [_vm._v("\n      team@unifiproperty.com COPYRIGHT 2020\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [_c("span", [_vm._v("Update your password")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "margin-bottom": "140px" } }, [
      _vm._v("\n          You have Successfully updated"),
      _c("br"),
      _vm._v("your password.\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f7f5a82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f7f5a82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/update.vue
// module id = null
// module chunks = 